// import http from "./http";

// /* =========================
//    GET ALL CAMPAIGNS
// ========================= */
// export const getCampaigns = async () => {
//   const res = await http.get("campaigns?action=get");
//   return res.data;
// };

// /* =========================
//    GET SINGLE CAMPAIGN
// ========================= */
// export const getCampaignById = async (id) => {
//   const res = await http.get(`campaigns?action=get&id=${id}`);
//   return res.data;
// };

// /* =========================
//    CREATE CAMPAIGN
// ========================= */
// export const createCampaign = async (payload) => {
//   const res = await http.post(
//     "campaigns?action=add",
//     payload,
//     { headers: { "Content-Type": "application/json" } }
//   );
//   return res.data;
// };

// /* =========================
//    UPDATE CAMPAIGN
// ========================= */
// export const updateCampaign = async (id, payload) => {
//   const res = await http.post(
//     `campaigns?action=update&id=${id}`,
//     payload,
//     { headers: { "Content-Type": "application/json" } }
//   );
//   return res.data;
// };

// /* =========================
//    DELETE CAMPAIGN
// ========================= */
// export const deleteCampaign = async (id) => {
//   const res = await http.post(
//     `campaigns?action=delete&id=${id}`,
//     {},
//     { headers: { "Content-Type": "application/json" } }
//   );
//   return res.data;
// };

// /* =========================
//    ASSIGN USER TO CAMPAIGN
// ========================= */
// export const assignUserToCampaign = async (campaign_id, user_id, role) => {
//   const res = await http.post(
//     "campaigns?action=assign",
//     {
//       campaign_id,
//       user_id,
//       role, // tm | sales | user
//     },
//     { headers: { "Content-Type": "application/json" } }
//   );
//   return res.data;
// };

// /* =========================
//    GET CAMPAIGN USERS
// ========================= */
// export const getCampaignUsers = async (campaign_id) => {
//   const res = await http.get(
//     `campaigns?action=users&campaign_id=${campaign_id}`
//   );
//   return res.data;
// };

// /* =========================
//    GET CAMPAIGN STATS
// ========================= */
// export const getCampaignStats = async (campaign_id) => {
//   const res = await http.get(
//     `campaigns?action=stats&campaign_id=${campaign_id}`
//   );
//   return res.data;
// };





import http from "./http";

/* =========================
   GET ALL CAMPAIGNS
========================= */
export const getCampaigns = async () => {
  const res = await http.get("campaigns?action=get");
  return res.data;
};

/* =========================
   GET SINGLE CAMPAIGN
========================= */
export const getCampaignById = async (id) => {
  const res = await http.get(`campaign_details?campaign_id=${id}`);
  return res.data;
};




/* =========================
   CREATE CAMPAIGN
========================= */
export const createCampaign = async (payload) => {
  const res = await http.post(
    "campaigns?action=add",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};


export const getTeamManagers = async () => {
  const res = await http.post("tm_sale_all_user?action=tm");
  return res.data;
};

export const getSalesUsers = async () => {
  const res = await http.post("tm_sale_all_user?action=sales");
  return res.data;
};

export const getUsers = async () => {
  const res = await http.post("users?action=get_users");
  return res.data;
};

/* =========================
   UPDATE CAMPAIGN ✅ FIXED
========================= */
export const updateCampaign = async (id, payload) => {
  const res = await http.post(
    "campaigns?action=update",
    { id, ...payload },   // ✅ ID IN BODY
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

/* =========================
   DELETE CAMPAIGN ✅ FIXED
========================= */
export const deleteCampaign = async (id) => {
  const res = await http.post(
    "campaigns?action=delete",
    { id },               // ✅ ID IN BODY
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

/* =========================
   ASSIGN USER TO CAMPAIGN
========================= */
// export const assignUserToCampaign = async (campaign_id, user_id, role) => {
//   const res = await http.post(
//     "campaigns?action=assign",
//     { campaign_id, user_id, role },
//     { headers: { "Content-Type": "application/json" } }
//   );
//   return res.data;
// };

export const assignUserToCampaign = async (payload) => {
  const res = await http.post(
    "campaigns?action=assign",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};


